import React from 'react';
import { useServices } from '../../context/CMSContext';
import { Icon } from '../../utils/icons';

const Features: React.FC = () => {
  const services = useServices();
  if (!services.enabled) return null;

  return (
    <section id="services" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-gold-700 text-sm font-bold uppercase tracking-[0.2em]">{services.sectionTagline}</span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-3 mb-4">{services.sectionTitle}</h2>
          <div className="w-16 h-1 bg-gold-600 mx-auto mb-6"></div>
          <p className="text-slate-600">{services.sectionDescription}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.items.map((feature) => (
            <div
              key={feature.id}
              className="p-8 rounded-xl bg-slate-50 hover:bg-white hover:shadow-xl transition-all duration-300 group"
            >
              <div className="mb-6 transform group-hover:scale-110 transition-transform duration-300">
                <Icon name={feature.icon} className="w-10 h-10 text-gold-600" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-4">{feature.title}</h3>
              <p className="text-slate-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
